"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringToWorkCategory = exports.workCategoryToString = exports.WorkCategory = exports.workSystemToString = exports.workStateToString = exports.workTypeToString = exports.WorkOrder = exports.WorkState = exports.WorkUrgency = exports.WorkType = exports.WorkSystem = exports.decodeWorkOrder = exports.decodeWorkOrders = void 0;

var workorder_1 = require("./http/workorder");
/**
 * decodeWorkOrders decodes an API originating work orders array into an array of WorkOrder:s
 * @param w API originating WorkOrder-array.
 * @returns an array of decoded WorkOrder
 */


function decodeWorkOrders(w) {
  var e_1, _a;

  var orders = [];

  try {
    for (var w_1 = __values(w), w_1_1 = w_1.next(); !w_1_1.done; w_1_1 = w_1.next()) {
      var order = w_1_1.value;
      orders.push(decodeWorkOrder(order));
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (w_1_1 && !w_1_1.done && (_a = w_1.return)) _a.call(w_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return orders;
}

exports.decodeWorkOrders = decodeWorkOrders;
/**
 * decodeWorkOrder decodes a single API originating work order into a WorkOrder, primarily designed to be called from decodeWorkOrders
 * @param w API originating WorkOrder object
 * @returns a decoded WorkOrder
 */

function decodeWorkOrder(w) {
  var failed;
  var created;
  var approved;
  var performStart;
  var performEnd;
  var completed;

  if (w.Failed && w.Failed.Time !== "0001-01-01T00:00:00Z") {
    failed = parseWorkOrderEvent(w.Failed);
  }

  if (w.Created && w.Created.Time !== "0001-01-01T00:00:00Z") {
    created = parseWorkOrderEvent(w.Created);
  }

  if (w.Approved && w.Approved.Time !== "0001-01-01T00:00:00Z") {
    approved = parseWorkOrderEvent(w.Approved);
  }

  if (w.PerformStart && w.PerformStart.Time !== "0001-01-01T00:00:00Z") {
    performStart = parseWorkOrderEvent(w.PerformStart);
  }

  if (w.PerformEnd && w.PerformEnd.Time !== "0001-01-01T00:00:00Z") {
    performEnd = parseWorkOrderEvent(w.PerformEnd);
  }

  if (w.Completed && w.Completed.Time !== "0001-01-01T00:00:00Z") {
    completed = parseWorkOrderEvent(w.Completed);
  }

  var wo = new WorkOrder(w.Id, w.System, w.Type, w.Urgency, w.Note, w.Data, new Date(w.PerformAt), w.PerformBy);
  wo.failed = failed;
  wo.created = created;
  wo.approved = approved;
  wo.performStart = performStart;
  wo.performEnd = performEnd;
  wo.completed = completed;
  wo.state = w.State;
  return wo;
}

exports.decodeWorkOrder = decodeWorkOrder;
/**
 * parseWorkOrderEvent decodes an API originating WorkOrderEvent entry.
 * @param we a workorder event from the API
 * @returns a decoded WorkOrderEvent
 */

function parseWorkOrderEvent(we) {
  return {
    time: new Date(we.Time),
    user: we.User
  };
}

var WorkSystem;

(function (WorkSystem) {
  WorkSystem[WorkSystem["NotApplicable"] = 0] = "NotApplicable";
  WorkSystem[WorkSystem["EndDevice"] = 1] = "EndDevice";
  WorkSystem[WorkSystem["MeteringSystem"] = 2] = "MeteringSystem";
  WorkSystem[WorkSystem["MeterDataManagement"] = 3] = "MeterDataManagement";
  WorkSystem[WorkSystem["Other"] = 4] = "Other";
  WorkSystem[WorkSystem["External"] = 5] = "External"; // Manufacturers, field staff etc
})(WorkSystem = exports.WorkSystem || (exports.WorkSystem = {}));

;
/* NOTE: If you change this make sure you also change the serializer and the category function */

var WorkType;

(function (WorkType) {
  WorkType[WorkType["Invalid"] = 0] = "Invalid";
  WorkType[WorkType["ReadRequest"] = 1] = "ReadRequest";
  WorkType[WorkType["DeviceConfig"] = 2] = "DeviceConfig";
  WorkType[WorkType["Order"] = 3] = "Order";
  WorkType[WorkType["Manufacturing"] = 4] = "Manufacturing";
  WorkType[WorkType["Shipping"] = 5] = "Shipping";
  WorkType[WorkType["Installation"] = 6] = "Installation";
  WorkType[WorkType["PortConfig"] = 7] = "PortConfig";
  WorkType[WorkType["SWUpdate"] = 8] = "SWUpdate";
  WorkType[WorkType["StateChange"] = 9] = "StateChange";
  WorkType[WorkType["ReleaseChannelChange"] = 10] = "ReleaseChannelChange";
  WorkType[WorkType["ProfileChange"] = 11] = "ProfileChange";
  WorkType[WorkType["DeviceAction"] = 12] = "DeviceAction";
  WorkType[WorkType["LogDownload"] = 13] = "LogDownload";
  WorkType[WorkType["UnInstallation"] = 14] = "UnInstallation";
  WorkType[WorkType["PowerUpTest"] = 15] = "PowerUpTest";
  WorkType[WorkType["FactoryTest"] = 16] = "FactoryTest";
  WorkType[WorkType["SelfTest"] = 17] = "SelfTest";
  WorkType[WorkType["Approval"] = 18] = "Approval";
  WorkType[WorkType["InstallationRequest"] = 19] = "InstallationRequest";
  WorkType[WorkType["Assembly"] = 20] = "Assembly";
  WorkType[WorkType["ModemCheck"] = 21] = "ModemCheck";
  WorkType[WorkType["BandwidthTest"] = 22] = "BandwidthTest";
  WorkType[WorkType["Restart"] = 23] = "Restart";
  WorkType[WorkType["Discover"] = 24] = "Discover";
  WorkType[WorkType["ConfigDeploy"] = 25] = "ConfigDeploy";
  WorkType[WorkType["ChangeOwnership"] = 26] = "ChangeOwnership";
  WorkType[WorkType["SendCommand"] = 27] = "SendCommand";
  WorkType[WorkType["Note"] = 28] = "Note";
  WorkType[WorkType["RemoveRelationship"] = 29] = "RemoveRelationship";
  WorkType[WorkType["Delete"] = 30] = "Delete";
})(WorkType = exports.WorkType || (exports.WorkType = {}));

;
var WorkUrgency;

(function (WorkUrgency) {
  WorkUrgency[WorkUrgency["Invalid"] = 0] = "Invalid";
  WorkUrgency[WorkUrgency["Now"] = 1] = "Now";
  WorkUrgency[WorkUrgency["NextConnection"] = 2] = "NextConnection";
  WorkUrgency[WorkUrgency["AtTime"] = 3] = "AtTime";
})(WorkUrgency = exports.WorkUrgency || (exports.WorkUrgency = {}));

;
var WorkState;

(function (WorkState) {
  WorkState[WorkState["Failed"] = 0] = "Failed";
  WorkState[WorkState["Created"] = 1] = "Created";
  WorkState[WorkState["Approved"] = 2] = "Approved";
  WorkState[WorkState["PerformStart"] = 3] = "PerformStart";
  WorkState[WorkState["PerformEnd"] = 4] = "PerformEnd";
  WorkState[WorkState["Completed"] = 5] = "Completed";
})(WorkState = exports.WorkState || (exports.WorkState = {}));

;
/** WorkOrder is a class for a single work order, its associated data and life cycle */

var WorkOrder =
/** @class */
function () {
  function WorkOrder(id, system, type, urgency, note, data, performAt, performBy) {
    if (id === void 0) {
      id = 0;
    }

    if (system === void 0) {
      system = WorkSystem.NotApplicable;
    }

    if (type === void 0) {
      type = WorkType.Invalid;
    }

    if (urgency === void 0) {
      urgency = WorkUrgency.Invalid;
    }

    if (note === void 0) {
      note = "";
    }

    this.id = id;
    this.system = system;
    this.type = type;
    this.urgency = urgency;
    this.state = WorkState.Created;
    this.data = data;

    if (typeof data === "string" && data.length > 2) {
      try {
        this.data = JSON.parse(data);
      } catch (SyntaxError) {
        console.error("Work order with id: " + this.id + " contained data not parsable as JSON. \nData was: " + data);
      }
    } else if (data != null) {
      this.data = data;
    } else {
      this.data = {};
    }

    this.note = note;

    if (performAt) {
      this.performAt = performAt;
    }

    if (performBy) {
      this.performBy = performBy;
    }
  }
  /**
   * Create a new work order based on this work order.
   * @param uuid The UUID of the device which this work order belongs to
   * @param credentials The sign in credentials to allow such a manoeuver
   * @param approve (default=false) The work order should be automatically approved
   */


  WorkOrder.prototype.create = function (uuid, credentials, approve) {
    var _this = this;

    if (approve === void 0) {
      approve = false;
    }

    return workorder_1.createWorkOrder(uuid, this, credentials, approve).then(function (res) {
      var wo = decodeWorkOrder(res.data);
      _this.id = wo.id;
      _this.state = WorkState.Created;
      _this.created = wo.created;
      return wo;
    });
  };
  /**
   * Approve a created work order.
   * @param uuid The UUID of the device which this work order belongs to
   * @param credentials The sign in credentials to allow such a manoeuver
   */


  WorkOrder.prototype.approve = function (uuid, credentials) {
    var _this = this;

    if (this.id > 0 && this.state === WorkState.Created) {
      return workorder_1.approveWorkOrder(uuid, this.id, this, credentials).then(function (res) {
        var wo = decodeWorkOrder(res.data);
        _this.state = WorkState.Approved;
        _this.approved = wo.approved;
        return wo;
      });
    }

    throw Error("Unable to approve work order because ID (" + this.id + ") is missing or is in wrong state: " + this.state);
  };
  /**
   * Cancel a work order. This requires the work order to be in a state less than PerformStar (e.g. Created or Approved)
   * @param uuid The UUID of the device which this work order belongs to
   * @param credentials The sign in credentials to allow such a manoeuver
   */


  WorkOrder.prototype.cancel = function (uuid, credentials) {
    var _this = this;

    if (this.id > 0 && this.state < WorkState.PerformStart) {
      return workorder_1.cancelWorkOrder(uuid, this.id, this, credentials).then(function (res) {
        var wo = decodeWorkOrder(res.data);
        _this.state = WorkState.Failed;
        _this.note = wo.note;
        return wo;
      });
    }

    throw Error("Unable to cancel work order because ID (" + this.id + ") is missing or is in wrong state: " + this.state);
  };
  /**
   * Retry a failed or completed work order, this will create a new work order "copy" of this work order.
   * This requires the work order to be in the states Failed or Completed
   * @param uuid The UUID of the device which this work order belongs to
   * @param credentials The sign in credentials to allow such a manoeuver
   */


  WorkOrder.prototype.retry = function (uuid, credentials) {
    if (this.id > 0 && (this.state === WorkState.Failed || this.state === WorkState.Completed)) {
      return workorder_1.retryWorkOrder(uuid, this.id, this, credentials).then(function (res) {
        var wo = decodeWorkOrder(res.data);
        return wo;
      });
    }

    throw Error("Unable to retry work order because ID (" + this.id + ") is missing or is in wrong state: " + this.state);
  };
  /** Stores a work order as is
   * @deprecated Use create, approve, cancel or retry to store work orders
  */


  WorkOrder.prototype.store = function (uuid, credentials) {
    return workorder_1.createWorkOrder(uuid, this, credentials, true);
  };
  /** Categorizes the work order for grouping */


  WorkOrder.prototype.category = function () {
    if (this.type === WorkType.Order || this.type === WorkType.Manufacturing || this.type === WorkType.Shipping || this.type === WorkType.Installation || this.type === WorkType.UnInstallation || this.type === WorkType.PowerUpTest || this.type === WorkType.FactoryTest || this.type === WorkType.SelfTest || this.type === WorkType.Approval || this.type === WorkType.InstallationRequest || this.type === WorkType.Assembly || this.type === WorkType.Delete) {
      return WorkCategory.Lifecycle;
    }

    if (this.type === WorkType.PortConfig || this.type === WorkType.ProfileChange || this.type === WorkType.StateChange || this.type === WorkType.DeviceConfig || this.type === WorkType.ConfigDeploy || this.type === WorkType.RemoveRelationship) {
      return WorkCategory.Configuration;
    }

    if (this.type === WorkType.SWUpdate || this.type === WorkType.ReleaseChannelChange || this.type === WorkType.ChangeOwnership) {
      return WorkCategory.System;
    }

    if (this.type === WorkType.DeviceAction || this.type === WorkType.LogDownload || this.type === WorkType.ReadRequest || this.type === WorkType.ModemCheck || this.type === WorkType.BandwidthTest || this.type === WorkType.Restart || this.type === WorkType.Discover || this.type === WorkType.SendCommand || this.type === WorkType.Note) {
      return WorkCategory.Operations;
    }

    return WorkCategory.All;
  };

  ;
  return WorkOrder;
}();

exports.WorkOrder = WorkOrder;

function workTypeToString(type) {
  var output = 'Unknown';

  switch (type) {
    case WorkType.Invalid:
      output = 'Invalid';
      break;

    case WorkType.ReadRequest:
      output = 'Instantaneous Meter Read';
      break;

    case WorkType.DeviceConfig:
      output = 'Device Configuration';
      break;

    case WorkType.Order:
      output = 'Product Order';
      break;

    case WorkType.Manufacturing:
      output = 'Manufacturing';
      break;

    case WorkType.Shipping:
      output = 'Shipping';
      break;

    case WorkType.Installation:
      output = 'Installation';
      break;

    case WorkType.PortConfig:
      output = 'Reading Frequency Change';
      break;

    case WorkType.SWUpdate:
      output = 'Firmware Upgrade';
      break;

    case WorkType.StateChange:
      output = 'Manual state change';
      break;

    case WorkType.ReleaseChannelChange:
      output = 'Firmware release channel change';
      break;

    case WorkType.ProfileChange:
      output = 'Profile assignment';
      break;

    case WorkType.DeviceAction:
      output = 'Device action';
      break;

    case WorkType.LogDownload:
      output = 'Log download';
      break;

    case WorkType.UnInstallation:
      output = 'Uninstallation';
      break;

    case WorkType.PowerUpTest:
      output = 'Power up test';
      break;

    case WorkType.FactoryTest:
      output = 'Factory test';
      /* FAT */

      break;

    case WorkType.SelfTest:
      output = 'Self test';
      break;

    case WorkType.Approval:
      output = 'Approval';
      break;

    case WorkType.InstallationRequest:
      output = 'Installation Request';
      break;

    case WorkType.Assembly:
      output = 'Product assembly';
      break;

    case WorkType.ModemCheck:
      output = 'Modem check';
      break;

    case WorkType.BandwidthTest:
      output = 'Bandwidth test';
      break;

    case WorkType.Restart:
      output = 'Restart';
      break;

    case WorkType.Discover:
      output = 'Device discovery';
      break;

    case WorkType.ConfigDeploy:
      output = 'Configuration deployment';
      break;

    case WorkType.ChangeOwnership:
      output = 'Change ownership';
      break;

    case WorkType.SendCommand:
      output = 'Send device commands';
      break;

    case WorkType.Note:
      output = 'Note';
      break;

    case WorkType.Delete:
      output = 'Delete';
      break;

    default:
      output = 'Unknown';
      break;
  }

  return output;
}

exports.workTypeToString = workTypeToString;

function workStateToString(state) {
  var output = 'Unknown';

  switch (state) {
    case WorkState.Failed:
      output = 'Failed';
      break;

    case WorkState.Created:
      output = 'Created';
      break;

    case WorkState.Approved:
      output = 'Approved';
      break;

    case WorkState.PerformStart:
      output = 'In Progress';
      break;

    case WorkState.PerformEnd:
      output = 'Performed';
      break;

    case WorkState.Completed:
      output = 'Completed';
      break;

    default:
      output = 'Unknown';
      break;
  }

  return output;
}

exports.workStateToString = workStateToString;

function workSystemToString(system) {
  var output = 'Unknown';

  switch (system) {
    case WorkSystem.NotApplicable:
      output = 'Not applicable';
      break;

    case WorkSystem.EndDevice:
      output = 'End Device';
      break;

    case WorkSystem.MeteringSystem:
      output = 'Metering System';
      break;

    case WorkSystem.MeterDataManagement:
      output = 'Meter Data Management';
      break;

    case WorkSystem.Other:
      output = 'Other';
      break;

    case WorkSystem.External:
      output = 'External';
      break;

    default:
      output = 'Unknown';
      break;
  }

  return output;
}

exports.workSystemToString = workSystemToString;
var WorkCategory;

(function (WorkCategory) {
  WorkCategory[WorkCategory["All"] = 0] = "All";
  WorkCategory[WorkCategory["Lifecycle"] = 1] = "Lifecycle";
  WorkCategory[WorkCategory["Configuration"] = 2] = "Configuration";
  WorkCategory[WorkCategory["System"] = 3] = "System";
  WorkCategory[WorkCategory["Operations"] = 4] = "Operations";
})(WorkCategory = exports.WorkCategory || (exports.WorkCategory = {}));

exports.workCategoryToString = function (v) {
  if (v === WorkCategory.All) {
    return "all";
  }

  if (v === WorkCategory.Lifecycle) {
    return "life-cycle";
  }

  if (v === WorkCategory.Configuration) {
    return "configuration";
  }

  if (v === WorkCategory.System) {
    return "system";
  }

  if (v === WorkCategory.Operations) {
    return "operations";
  }

  return "all";
};

exports.stringToWorkCategory = function (s) {
  if (s === "all") {
    return WorkCategory.All;
  }

  if (s === "life-cycle") {
    return WorkCategory.Lifecycle;
  }

  if (s === "configuration") {
    return WorkCategory.Configuration;
  }

  if (s === "system") {
    return WorkCategory.System;
  }

  if (s === "operations") {
    return WorkCategory.Operations;
  }

  return WorkCategory.All;
};

exports.default = WorkOrder;